import { parsePayloadForQuery } from '@/helpers/utils.js';
import axios from 'axios';
import Vue from 'vue';

export const MODAL_NAME = {
  CREATE: 'create',
  EDIT_DETAILS: 'editDetails',
  GRANT_ROLE: 'grantRole',
  ASSIGN_USER: 'assignUser',
  GRANT_REPORT: 'grantReport',
}

const state = {
  items: [],
  modals: {
    create: false,
    editDetails: false,
    grantRole: false,
    assignUser: false,
    grantReport: false
  },
  item: null
};

const getters = {
  getItem: state => state.item,
  getItems: state => state.items,
  isOpen: (state) => (modalName) => state.modals[modalName]
};

const mutations = {
  itemsLoaded(state, payload) {
    state.items = payload;
  },
  itemLoaded(state, payload) {
    state.item = payload;
  },
  open(state, modalName) {
    Vue.set(state.modals, modalName, true);
  },
  close(state, modalName) {
    Vue.set(state.modals, modalName, false);
  },
};

const actions = {
  get(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/security-groups${queryParams}`);
  },
  getUsers(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/security-groups/users/all${queryParams}`);
  },
  getRoles(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/security-groups/roles/all${queryParams}`);
  },
  getReports(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/security-groups/reports/all${queryParams}`);
  },
  create(state, payload) {
    return axios.post(`/security-groups`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Create company - ERROR - ', data.failures[0].error);
          throw data.failures[0];
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  edit(state, payload) {
    return axios.patch(`/security-groups`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Edit company - ERROR - ', data.failures[0].error);
          throw data.failures[0];
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  updateRoles(state, payload) {
    return axios.post(`/security-groups/update-roles`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Edit Roles Assignment - ERROR - ', data.failures);
          throw data.failures;
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  updateUsers(state, payload) {
    return axios.post(`/security-groups/update-users`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Edit Users Assignment - ERROR - ', data.failures);
          throw data.failures;
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  updatePbiReports(state, payload) {
    return axios.post(`/security-groups/update-pbi-reports`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Edit PBI Reports Assignment - ERROR - ', data.failures);
          throw data.failures;
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  delete(state, payload) {
    return axios.delete(`/security-groups?ids=${payload}`)
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};